/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ShowModuleContentApplicationValues } from './showModuleContentApplicationModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'show-module-content-application-modal',
    standalone: false,
})
export class ShowModuleContentApplicationModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<void>;
    @Input() resolve: ShowModuleContentApplicationValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('showModuleContentApplicationModal', elementRef, injector);
    }
}
